
export default function ServicesSection() {
  const services = [
    {
      title: 'PPCP',
      subtitle: 'Planejamento e Controle da Produção',
      icon: 'ri-line-chart-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20production%20planning%20control%20room%20with%20multiple%20monitors%20displaying%20KPI%20dashboards%2C%20OEE%20metrics%2C%20production%20schedules%2C%20clean%20professional%20environment%2C%20charts%20and%20graphs%20visible%20on%20screens%2C%20industrial%20setting%20with%20control%20panels%2C%20data%20visualization%20displays%2C%20professional%20lighting%2C%20organized%20workspace%20with%20planning%20documents&width=400&height=300&seq=ppcp-service&orientation=landscape',
      services: [
        'Planejamento Mestre de Produção',
        'Sequenciamento de Operações',
        'Balanceamento de Linhas',
        'S&OP Básico',
        'Indicadores OTD/OEE/Produtividade'
      ],
      cta: 'Otimizar Produção'
    },
    {
      title: 'Projetos & Obras',
      subtitle: 'Gestão Completa de Projetos',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=Construction%20project%20management%20scene%20with%20architectural%20blueprints%2C%20BIM%20models%20on%20computer%20screen%2C%20construction%20site%20in%20background%2C%20engineering%20tools%2C%20measuring%20equipment%2C%20hard%20hat%20and%20safety%20gear%2C%20professional%20desk%20setup%20with%20project%20schedules%2C%20cost%20estimates%2C%20construction%20documents%2C%20modern%20office%20environment&width=400&height=300&seq=projects-service&orientation=landscape',
      services: [
        'Elaboração de Cronogramas',
        'Orçamentos Detalhados',
        'Laudos e Vistorias Técnicas',
        'Compatibilização BIM/Revit',
        'Acompanhamento de Execução'
      ],
      cta: 'Gerir Projeto'
    },
    {
      title: 'Segurança do Trabalho',
      subtitle: 'Prevenção e Conformidade',
      icon: 'ri-shield-check-line',
      image: 'https://readdy.ai/api/search-image?query=Workplace%20safety%20training%20session%20in%20industrial%20environment%2C%20safety%20equipment%20display%2C%20hard%20hats%2C%20safety%20vests%2C%20risk%20assessment%20documents%2C%20safety%20protocols%20checklist%2C%20professional%20training%20materials%2C%20industrial%20background%20with%20safety%20signage%2C%20clean%20organized%20safety%20demonstration%20area&width=400&height=300&seq=safety-service&orientation=landscape',
      services: [
        'Análise de Riscos Ocupacionais',
        'Elaboração de POPs',
        'Treinamentos de Segurança',
        'Laudos Técnicos',
        'Conformidade Regulatória'
      ],
      cta: 'Garantir Segurança'
    }
  ];

  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">
            Meus <span className="text-yellow-600">Serviços</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Soluções especializadas em engenharia para empresas e construtoras, 
            focando em resultados mensuráveis e conformidade técnica.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center">
                    <i className={`${service.icon} text-xl text-black`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-yellow-600 font-medium mb-6">{service.subtitle}</p>
                
                <ul className="space-y-3 mb-8">
                  {service.services.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-check-line text-yellow-600 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
                
                <button 
                  onClick={scrollToContact}
                  className="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 rounded-lg hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  {service.cta}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
